//import { gsap } from "gsap";
import { gsap } from "node_modules/gsap/index.js";
import ScrollToPlugin from "node_modules/gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
export class AnchorLink {
    constructor(link) {
        // Handle jQuery object or HTMLElement
        this.link = link instanceof HTMLElement ? link : (link[0] || link);
        if (!this.link || !(this.link instanceof HTMLElement))
            return;
        const href = this.link.href || "";
        const hashIndex = href.indexOf("#");
        if (hashIndex === -1)
            return;
        const hash = href.substring(hashIndex);
        if (hash.length < 4) {
            return;
        }
        this.target = hash;
        if (hash.indexOf(".") > -1 || hash.indexOf(" ") > -1 || hash.indexOf(",") > -1 || hash.indexOf("%") > -1 || hash.indexOf("=") > -1 || hash.indexOf("/") > -1) {
            //l("returning with hash " + hash);
            return;
        }
        const elem = document.querySelector(hash);
        if (elem) {
            this.link.addEventListener("click", (e) => this.onAnchorClick(e));
        }
    }
    onAnchorClick(e) {
        const mouseEvent = e;
        let target;
        if (this.link.dataset.target === "self") {
            target = this.link;
        }
        else {
            target = document.querySelector(this.target);
        }
        if (target) {
            mouseEvent.preventDefault();
            gsap.to(window, { duration: 1, scrollTo: { y: this.target, offsetY: 32 } });
            return false;
        }
    }
}
